import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Business Type Classification Translations',
  basePath: '/btc-translations',
  columns: [
    { key: 'language_title', label: 'Language', sortable: true },
    { key: 'business_type_title', label: 'Title', sortable: true },
    { key: 'translation', label: 'Translation', sortable: true },
  ],
  fields: [
    { key: 'lang', label: 'Language', type: 'async-select',
      optionsUrl: '/countries/options',
      placeholder: 'Select language', required: true },
    { key: 'business_type_pid', label: 'Title', type: 'async-select',
      optionsUrl: '/btc-vars/options',
      dependsOn: ['lang'],
      valuesParams: { lang: 'lang' },
      visible: (v) => !!v.lang,
      placeholder: 'Select translation title' },
    { key: 'translation', label: 'Translation', type: 'textarea',
      dependsOn: ['lang'],
      visible: (v) => !!v.lang },
  ],
  filters: [
    { key: 'country', label: 'Language', type: 'select',
      optionsUrl: '/countries/options' },
  ],
  defaultSort: { field: 'language_title', dir: 'asc' },
});
